"use client"

import {
  useStyle 
} from "@/classify"
import Button from "@/components/Button"
import Image from "next/image"
import {
  useRouter 
} from "next/navigation"
import {
  useCallback 
} from "react"
import notFoundImage from "./404.svg"
import defaultClasses from "./errorView.module.css"

const DEFAULT_HEADER = "Oops!"
const DEFAULT_MESSAGE =
    "Looks like the page you were hoping to find doesn’t exist, sorry about that."
const DEFAULT_PROMPT = "Take me home"

const ErrorView = (props) => {
  const classes = useStyle(defaultClasses, props.classes)

  const router = useRouter()

  const handleGoHome = useCallback(() => {
    router.push("/")
  }, [router])

  const {
    onClick = handleGoHome 
  } = props

  const handleClick = useCallback(() => {
    onClick && onClick()
  }, [onClick])

  return (
    <div className={classes.root} data-cy='ErrorView-root'>
      <Image
        width={532}
        height={515}
        src={notFoundImage}
        className={classes.image}
        alt='not found'
      />
      <div className={classes.content}>
        <h2 className={classes.title}>{DEFAULT_HEADER}</h2>
        <p className={classes.text}>{DEFAULT_MESSAGE}</p>
        <Button className={classes.button} onClick={handleClick}>
          {DEFAULT_PROMPT}
        </Button>
      </div>
    </div>
  )
}

export default ErrorView
